export default "__VITE_ASSET__CSSsD2qC__"